function switchFavoriteTab(event) {
	if (dragging) return;

	var target = event.target.closest(".links-buttons .links a[data-tab]");
	if (target) {
		if (!target.classList.contains("active")) {
			event.preventDefault();

			var activeTab = document.querySelector(".links-buttons .links a[data-tab].active");
			activeTab.classList.remove("active");
			document.querySelector(".favorite-tabs .tab[data-tab=" + activeTab.getAttribute("data-tab") + "]").classList.remove("active");

			target.classList.add("active");
			document.querySelector(".favorite-tabs .tab[data-tab=" + target.getAttribute("data-tab") + "]").classList.add("active");
		}
	}
}

document.addEventListener("click", switchFavoriteTab);
document.addEventListener("touchend", switchFavoriteTab);